import { Stack, Typography } from '@mui/material';

import { SpinningIcon } from '@/components/animation/SpinningIcon/SpinningIcon';
import { RefreshCw05Icon } from '@/components/icons/RefreshCw05Icon';

export interface GeneratingIndicatorProps {
  dataTestId: string;
}

export function GeneratingIndicator({ dataTestId }: GeneratingIndicatorProps) {
  return (
    <Stack
      direction="row"
      spacing={0.5}
      alignItems="center"
      data-testid={`${dataTestId}-generating-indicator`}
      role="status"
      aria-live="polite"
    >
      <SpinningIcon Icon={RefreshCw05Icon} size={14} />
      <Typography
        variant="body-xs"
        sx={{
          fontWeight: 500,
        }}
      >
        Generating...
      </Typography>
    </Stack>
  );
}
